module.exports = __webpack_public_path__ + "static/media/wackyshack.2ba09ceb.gif";